/**
 * Collection Vehicle Filter
 * Handles client-side filtering of products by Make, Model, Year
 * Works with LIST-TYPE metafields (arrays)
 */

class CollectionVehicleFilter {
  constructor() {
    this.productGrid = document.querySelector('.collection');
    this.products = [];
    this.init();
  }
  
  async init() {
    // Get filter parameters from URL
    const urlParams = new URLSearchParams(window.location.search);
    const make = urlParams.get('filter.p.m.magento.make_filter') || urlParams.get('make');
    const model = urlParams.get('filter.p.m.magento.model_filter') || urlParams.get('model');
    const year = urlParams.get('filter.p.m.magento.year_filter') || urlParams.get('year');
    
    // Only proceed if we have filter params
    if (!make && !model && !year) {
      return;
    }
    
    // IMPORTANT: If filter parameters are in the URL (from a redirect),
    // Shopify's native filtering has already filtered the products server-side.
    // We should NOT do client-side filtering in this case, as it will conflict
    // with Shopify's filtering and hide products incorrectly.
    // 
    // This client-side filtering should only be used for scenarios where
    // we're filtering without a page reload (which we're not doing currently).
    // 
    // When the vehicle filter form submits, it redirects with filter parameters,
    // so Shopify handles the filtering. We should let it work.
    console.log('Filter parameters detected in URL. Shopify native filtering should handle this. Skipping client-side filtering.');
    return;
    
    // The code below is disabled because it conflicts with Shopify's native filtering
    // when filter parameters are present in the URL after a redirect.
    /*
    // Fetch all products with vehicle data
    await this.fetchProducts();
    
    // Filter and display matching products
    this.filterProducts(make, model, year);
    */
  }
  
  async fetchProducts() {
    try {
      // Get the current collection handle
      const collectionHandle = window.location.pathname.split('/collections/')[1]?.split('?')[0] || 'all';
      
      
      const response = await fetch(`/collections/${collectionHandle}?view=vehicle-data`);
      
      if (!response.ok) {
        throw new Error(`Failed to fetch products: ${response.status}`);
      }
      
      this.products = await response.json();
      
    } catch (error) {
      console.error('Error fetching products:', error);
      this.products = [];
    }
  }
  
  filterProducts(make, model, year) {
    // Get all product cards on the page
    const productCards = document.querySelectorAll('.product-grid__item[data-product-id]');
    
    if (productCards.length === 0) {
      console.warn('No product cards found on page');
      return;
    }
    
    
    let visibleCount = 0;
    let hiddenCount = 0;
    
    // Filter each product card
    productCards.forEach(card => {
      const productId = parseInt(card.dataset.productId);
      const product = this.products.find(p => p.id === productId);
      
      if (!product) {
        // If we don't have data for this product, hide it
        card.style.display = 'none';
        hiddenCount++;
        return;
      }
      
      // Check if product matches filters
      const matches = this.productMatches(product, make, model, year);
      
      if (matches) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
        hiddenCount++;
      }
    });
    
    
    // Show message if no products match
    if (visibleCount === 0) {
      this.showNoResultsMessage(make, model, year);
    }
  }
  
  productMatches(product, make, model, year) {
    // Helper function to check if value exists in array or string
    const includes = (value, searchTerm) => {
      if (!value) return false;
      if (Array.isArray(value)) {
        return value.some(v => v && v.toString().toLowerCase() === searchTerm.toLowerCase());
      }
      return value.toString().toLowerCase() === searchTerm.toLowerCase();
    };
    
    // Debug logging for first product
    if (this.debugLogged !== true) {
      this.debugLogged = true;
    }
    
    // Check make
    if (make && !includes(product.make, make)) {
      return false;
    }
    
    // Check model
    if (model && !includes(product.model, model)) {
      return false;
    }
    
    // Check year
    if (year && !includes(product.year, year)) {
      return false;
    }
    
    return true;
  }
  
  showNoResultsMessage(make, model, year) {
    const filters = [make, model, year].filter(Boolean).join(' ');
    
    const message = document.createElement('div');
    message.className = 'collection-vehicle-filter__no-results';
    message.innerHTML = `
      <div class="page-width">
        <div class="empty-state">
          <h2>No products found for ${filters}</h2>
          <p>Try adjusting your vehicle selection or <a href="/collections/all">browse all products</a>.</p>
        </div>
      </div>
    `;
    
    // Insert after the collection header
    const collectionHeader = document.querySelector('.collection-hero') || 
                            document.querySelector('.page-header') ||
                            document.querySelector('.collection');
    
    if (collectionHeader) {
      collectionHeader.after(message);
    }
  }
}

// Initialize when DOM is ready
// Only initialize on collection pages
function initCollectionVehicleFilter() {
  // Check if we're on a collection page
  const pathMatch = window.location.pathname.match(/\/collections\/([^\/\?]+)/);
  if (!pathMatch) {
    // Not on a collection page, don't initialize
    return;
  }
  
  // Skip 'all' collection - it's not a specific collection
  const collectionHandle = pathMatch[1];
  if (collectionHandle === 'all') {
    return;
  }
  
  new CollectionVehicleFilter();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionVehicleFilter);
} else {
  initCollectionVehicleFilter();
}
